import { DateBox, LoadPanel, Popup } from "devextreme-react";
import { Table1 } from "../../../../Administration/Table1/Table1";
import { useEffect, useMemo, useState } from "react";
import { handleGetLocal } from "../../../../../services/auth-service";
import { ApiError } from "../../../../Error/ApiError";
import { drugTestScheduleTableTitle, setDrugTestScheduleTableColumnData } from "../Data";
import { ColumnDropdown } from "../../../../../components/Dropdownn";
import { logOut } from "../../../../../components/Logout";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import VoidTest from "./Popups/VoidTest";
import { AddEditDrugTestSchedule } from "./Popups/AddEditDrugTestSchedule";
import { DynamicTabb } from "../../../../../components/DynamicTab/DynamicTab";
import { useSelector } from "react-redux";
import { getDateBoxFormat } from "../../../../Dateapi/dateFormatter";
import { useScreenPermission } from "../../../../../hooks/useScreenPermission";
import { Download, Plus, RefreshCw } from "lucide-react";

const DropDown = ({ dropDownData, setfields, fields, fieldNmae, reset, disabled }) => {
  return (
    <>
      <ColumnDropdown
        data={dropDownData}
        setfields={setfields}
        fields={fields}
        fieldNmae={fieldNmae}
        value={fields[fieldNmae]?.name}
        reset={reset}
        disabled={disabled}
        margin={"0px"}
        width={"300px"}
      />
    </>
  );
};

export const DrugTestSchedule = () => {
  const drugTestScheduleMenu = true;
  const { participantdata } = useSelector((store) => store.participate);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const [drugTestScheduleData, setDrugTestScheduleData] = useState([]);
  const [fields, setFields] = useState({
    location: { name: "", id: "" },
  });
  const [locationDropdownValues, setLocationDropdownValues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [drugTestScheduleErrorHandling, setDrugTestScheduleErrorHandling] = useState(false);
  const [exportPopupOpen, setexportPopupOpen] = useState(false);
  const pathname = handleGetLocal("pathURL");
  const [drugTestScheduleRowData, setDrugTestScheduleRowData] = useState([]);
  const [voidPopup, setVoidPopup] = useState(false);
  const [addEditDrugTestSchedulePopup, setAddEditDrugTestSchedulePopup] = useState(false);
  const [drugTestScheduleType, setDrugTestScheduleType] = useState("Add");
  const [userDropdownValue, setUserDropdownValue] = useState([]);
  const [testDateDropdownValue, setTestDateDropdownValue] = useState([]);
  const [refreshing, setRefreshing] = useState(false);
  const navigate = useNavigate();
  const SCREEN_NAME = "DT9";
  const { permission, permissionLoading } = useScreenPermission(SCREEN_NAME, navigate);

  const getTodayDate = () => {
    const today = new Date();

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const [date, setdate] = useState(() => {
    const today = getTodayDate();

    try {
      const savedDates = JSON.parse(sessionStorage.getItem("drugTestScheduleDates") || "null");

      if (savedDates?.startDate && savedDates?.endDate) {
        return savedDates;
      }
    } catch (error) {
      console.error("Error reading Drug Test Schedule dates:", error);
    }

    return {
      startDate: today,
      endDate: today,
    };
  });

  const getLocationDropdownValues = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/RandomDrugTesting/dropdown`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        setLocationDropdownValues(val?.data?.data);
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  const getReportDateRange = async () => {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/RandomDrugTesting/get-drugtest-schedule?Location=${fields.location.id}&dStart=${date.startDate}&dEnd=${date.endDate}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        },
      )
      .then((val) => {
        setLoading(false);

        if (val?.data?.isSuccess) {
          setDrugTestScheduleErrorHandling(false);

          setDrugTestScheduleData(setDrugTestScheduleTableColumnData(val?.data?.data ?? []));
        } else {
          setDrugTestScheduleErrorHandling(true);
        }
      })
      .catch((error) => {
        if (!error?.response) {
          navigate(`/error/500`);
        } else if (error?.response?.status === 401) {
          logOut();
        } else {
          setDrugTestScheduleErrorHandling(true);
        }
      });
  };

  const getUserDropdownValue = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/RandomDrugTesting/drugtest-schedule-person-dropdown?Location=${fields.location.id}&dStart=${date.startDate}&dEnd=${date.endDate}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        },
      )
      .then((val) => {
        setUserDropdownValue(
          (val?.data?.data ?? []).map((item) => ({
            key: item?.gDrugTestRandomizerId,
            value: `${item?.sOffenderNumber ?? ""} - ${item?.sLastFirst ?? ""}`,
          })),
        );
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  const getTestDateDropdownValue = async () => {
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/RandomDrugTesting/get-test-date?Location=${fields.location.id}&dStart=${date.startDate}&dEnd=${date.endDate}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        },
      )
      .then((val) => {
        setTestDateDropdownValue(
          val?.data?.data?.map((item) => {
            return {
              "Test Time": item?.sTestTime,
              Slot: item?.iSlot,
              "Test Date": item?.sTestDate,
              gTestDateId: item?.gTestDateId,
              "Test Date Time": item?.sTestDateTime,
            };
          }),
        );
      })
      .catch((val) => {
        if (!val?.response) {
          navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  const handleRefresh = async () => {
    if (!fields.location?.id || loading || refreshing) return;

    setRefreshing(true);
    setDrugTestScheduleErrorHandling(false);

    try {
      await Promise.all([getReportDateRange(), getUserDropdownValue(), getTestDateDropdownValue()]);
    } finally {
      setRefreshing(false);
    }
  };

  useEffect(() => {
    if (fields.location.id) {
      if (date.endDate !== "Invalid Date" && date.startDate !== "Invalid Date") {
        getReportDateRange();
        getUserDropdownValue();
        getTestDateDropdownValue();
      }
    }
  }, [date, participantdata, fields.location?.id]);

  useEffect(() => {
    const locations = Array.isArray(locationDropdownValues?.location) ? locationDropdownValues.location : [];
    if (locations.length === 1) {
      setFields((prevFields) => ({
        ...prevFields,
        location: {
          name: locations[0].value,
          id: locations[0].key,
        },
      }));
    } else {
      setFields((prevFields) => ({
        ...prevFields,
        location: { name: "", id: "" },
      }));
    }
  }, [locationDropdownValues]);

  useEffect(() => {
    getLocationDropdownValues();
  }, []);

  const drugTestScheduleRows = useMemo(() => {
    return drugTestScheduleData.map((val, i) => ({
      ...val,
      ID: i,
    }));
  }, [drugTestScheduleData]);

  useEffect(() => {
    sessionStorage.setItem("drugTestScheduleDates", JSON.stringify(date));
  }, [date]);

  return (
    <>
      <LoadPanel shadingColor="true" visible={loading || permissionLoading} delay={10} />
      <Popup
        visible={voidPopup}
        onHiding={() => {
          setVoidPopup(false);
        }}
        showTitle={false}
        width={800}
        height={450}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <VoidTest
          voidPopup={voidPopup}
          setVoidPopup={setVoidPopup}
          voidHeading="Void Test Date"
          voidSubHeading="Void Test Date"
          setLoading={setLoading}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          rowData={drugTestScheduleRowData}
          apiURl="RandomDrugTesting/void-drugtest-schedule"
          refreshApi={getReportDateRange}
        />
      </Popup>
      <Popup
        visible={addEditDrugTestSchedulePopup}
        onHiding={() => {
          setAddEditDrugTestSchedulePopup(false);
        }}
        showTitle={false}
        width={680}
        height={350}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <AddEditDrugTestSchedule
          addEditDrugTestSchedulePopup={addEditDrugTestSchedulePopup}
          setAddEditDrugTestSchedulePopup={setAddEditDrugTestSchedulePopup}
          toastConfig={toastConfig}
          setToastConfig={setToastConfig}
          drugTestScheduleType={drugTestScheduleType}
          userDropdownValue={userDropdownValue}
          locationDropdownValues={locationDropdownValues}
          drugTestScheduleRowData={drugTestScheduleRowData}
          testDateDropdownValue={testDateDropdownValue}
          getReportDateRange={getReportDateRange}
        />
      </Popup>

      {!permission.view ? (
        <div style={{ padding: "20px", fontWeight: 600 }}>You do not have View access for DT.9.</div>
      ) : (
        <div className="page-content" style={{ margin: "20px 0", padding: "20px", background: "white" }}>
          <br />
          <DynamicTabb />
          <br />
          <p className="page-info-number">DT.9</p>
          <br />
          <div className="buttons dt9-toolbar">
            <div className="dt9-action-buttons">
              <button
                type="button"
                className="dt9-action-btn dt9-action-primary"
                disabled={!permission.add}
                onClick={() => {
                  if (!permission.add) return;

                  setAddEditDrugTestSchedulePopup(true);
                  setDrugTestScheduleType("Add");
                }}
              >
                <Plus size={18} strokeWidth={2.2} />
                <span>Add Test</span>
              </button>

              <button
                type="button"
                className="dt9-action-btn dt9-action-secondary"
                onClick={() => setexportPopupOpen(true)}
              >
                <Download size={18} strokeWidth={2} />
                <span>Export</span>
              </button>

              <button
                type="button"
                className="dt9-action-btn dt9-action-secondary"
                onClick={handleRefresh}
                disabled={!fields.location?.id || loading || refreshing || permissionLoading}
                title="Refresh Drug Test Schedule"
              >
                <RefreshCw size={18} strokeWidth={2} className={refreshing ? "dt9-refresh-spin" : ""} />
                <span>{refreshing ? "Refreshing..." : "Refresh"}</span>
              </button>
            </div>
            <div className="page-details-search-content">
              <div className="display-flex-div dropdown-space">
                <label className="edit_container_label">Drug Test Location</label>
                <DropDown
                  setfields={setFields}
                  fields={fields}
                  fieldNmae={"location"}
                  dropDownData={locationDropdownValues?.location?.map((vall) => {
                    return {
                      name: vall?.value,
                      id: vall?.key,
                    };
                  })}
                />
              </div>
              <div className="display-flex-div">
                <label className="edit_container_label">Period Start</label>
                <DateBox
                  type="date"
                  displayFormat={getDateBoxFormat()}
                  useMaskBehavior={true}
                  value={date.startDate}
                  onValueChange={(value) => {
                    if (value && !isNaN(new Date(value).getTime())) {
                      setdate((prev) => ({
                        ...prev,
                        startDate: value,
                      }));
                    }
                  }}
                />
              </div>
              <div className="display-flex-div">
                <label className="edit_container_label">Period End</label>
                <DateBox
                  type="date"
                  displayFormat={getDateBoxFormat()}
                  useMaskBehavior={true}
                  value={date.endDate}
                  onValueChange={(value) => {
                    if (value && !isNaN(new Date(value).getTime())) {
                      setdate((prev) => ({
                        ...prev,
                        endDate: value,
                      }));
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <br />
          <div className="drug-test-schedule" id="drug-test-schedule-grid">
            {drugTestScheduleErrorHandling ? (
              <ApiError />
            ) : (
              <Table1
                editTable={false}
                height={"auto"}
                Tablecoloum={drugTestScheduleTableTitle}
                tableRow={drugTestScheduleRows}
                load={loading}
                coloumWidthText={"Drug-Test-Schedule"}
                mandatoryColoum={"Test Date"}
                exportInDifferentFormate={true}
                exportPopupOpen={exportPopupOpen}
                setexportPopupOpen={setexportPopupOpen}
                exportwidth={27}
                exporttitle={"Drug-Test-Schedule"}
                drugTestScheduleMenu={drugTestScheduleMenu}
                drugTestScheduleRowData={drugTestScheduleRowData}
                setDrugTestScheduleRowData={setDrugTestScheduleRowData}
                setVoidPopup={setVoidPopup}
                setVoideFalse={true}
                setAddEditDrugTestSchedulePopup={setAddEditDrugTestSchedulePopup}
                setDrugTestScheduleType={setDrugTestScheduleType}
                drugTestScheduleEditAccess={permission.edit}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};
